<template>
    <div class="loading-widget-reasons">
        <h2>{{ title }}</h2>

        <div class="loader"></div>

        <ul class="reasons-to-book">
            <li v-for="(reason, index) in reasons" :key="index">
                <i :class="reason.icon"></i>
                <span class="text">
                    <strong>{{ reason.title }}</strong>
                    {{ reason.description }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'LoadingWidgetReasons',
    data() {
        return {

        }
    },
    props: {
        title: String,
        reasons: Array
    }
}
</script>